/**
 * Saga集合
 */
import common from './common/model';
import company from './company/model';
import service from './service/model';
import city from './city/model';

export default [
    ...Object.values(common.sagas),
    ...Object.values(company.sagas),
    ...Object.values(service.sagas),
    ...Object.values(city.sagas),
];